export const isInPopover = (elem, popoverElem) => popoverElem && popoverElem.contains(elem);